import MainHeader from "@/components/Tax Client Only/MainHeader/MainHeader";
import { Skeleton, AppShell } from "@mantine/core";

interface TaxOrganizerSkeletonProps {
  headerOpened: boolean;
  toggleHeader: () => void;
}

const TaxOrganizerSkeleton = ({
  headerOpened,
  toggleHeader,
}: TaxOrganizerSkeletonProps) => {
  return (
    <AppShell className="client-page" header={{ height: 77 }} padding="md">
      <AppShell.Header className="app-header">
        <MainHeader opened={headerOpened} toggle={toggleHeader} />
      </AppShell.Header>
      <AppShell.Main className="main">
        <div className="tax-organizer-home">
          <Skeleton height={40} width={200} mb="lg" />
          <Skeleton height={100} mb="lg" />
          <Skeleton height={100} mb="lg" />
        </div>
      </AppShell.Main>
    </AppShell>
  );
};

export default TaxOrganizerSkeleton;
